// Lee las métricas de Instagram de una marca por la edge `ig-metricas`. El token
// nunca pasa por acá. Ver ADR-2026-09-24-instagram-metricas.

import { supabase } from "./supabase";

export type AccionDeMetricas = "cuenta" | "posts" | "post" | "publico";

export interface PedidoDeMetricas {
  accion: AccionDeMetricas;
  dias?: number | null;
  orden?: string;
  cantidad?: number;
  post_id?: string;
}

/**
 * Lo que devuelve la edge. `conectada`/`disponible` + `mensaje` cuando el problema
 * es de la cuenta (vencida, sin permiso, Meta pidió esperar); el resto depende de
 * la acción y lo interpreta `chat-atlas/instagramEnElChat.ts`.
 */
export interface RespuestaDeMetricas {
  conectada: boolean;
  disponible?: boolean;
  estado?: string;
  mensaje?: string;
  [clave: string]: unknown;
}

export async function consultarMetricasDeInstagram(
  brandId: string | null,
  pedido: PedidoDeMetricas,
): Promise<RespuestaDeMetricas> {
  const { data, error } = await supabase.functions.invoke("ig-metricas", {
    body: { ...pedido, brand_id: brandId },
  });
  if (error) throw new Error(error.message || "No se pudieron leer las métricas de Instagram.");
  return data as RespuestaDeMetricas;
}
